import { types } from 'mobx-state-tree';

export const LangModel: any = types.model('LangModel', {
  _id: types.string,
  name: types.string,
  key: types.string
});
